<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Student tags'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Student tags'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                { text: 'Category', value: 'category.name', width: '150px' },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'studentTags/index',
            deleteItem: 'studentTags/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/student-tags/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/student-tags/add');
        }
    }
};
</script>
